"use strict";

exports.__esModule = true;
exports.createIntervalScale = createIntervalScale;
var _d3Scale = require("d3-scale");
/**
 * Create a UTC time scale for the given interval.
 */
function createIntervalScale(from, to, interval) {
  return (0, _d3Scale.scaleUtc)().range([from, to]).domain([interval.startMillis, interval.endMillis]);
}